import React, { Component } from "react";
import axios from "axios";
import getContent from 'pp-react-l10n';
import deserializeJSON from "../lib/jsonUtils";

class ThankyouHerocontainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { categorieValues, slugId="", isDownloadBtnExist=false } = this.props;
    const getTYContent = getContent('staticContent');
    const thankYouHeroInfo =
      categorieValues.length !== 0
        ? categorieValues.filter(item => item.content && item.content.ref_key && item.content.ref_key!=="" && item.content.ref_key.toLowerCase() === 'thank-you')
        : [];

    const palBlue = "circle at 0 0, #0070ba, #1546a0";
    const imageUrl =
      thankYouHeroInfo.length !== 0 &&
      thankYouHeroInfo[0].content &&
      thankYouHeroInfo[0].content.desc &&
      thankYouHeroInfo[0].content.desc!==undefined &&
      thankYouHeroInfo[0].content.desc.split("|") &&
      thankYouHeroInfo[0].content.desc.split("|")[0]
        ? thankYouHeroInfo[0].content.desc.split("|")[0]
        : "";

    const bgImageStyle =
      imageUrl !== ""
        ? {
            backgroundImage: `url(${imageUrl})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: "#0070ba",
          }
        : {
            backgroundColor: "#003087",
            backgroundImage: `radial-gradient(${palBlue})`,
          };

    const title =
      thankYouHeroInfo.length !== 0 &&
      thankYouHeroInfo[0].content &&
      thankYouHeroInfo[0].content.title
        ? thankYouHeroInfo[0].content.title
        : "";

    const description =
      thankYouHeroInfo.length !== 0 &&
      thankYouHeroInfo[0].content &&
      thankYouHeroInfo[0].content.desc &&
      thankYouHeroInfo[0].content.desc!==undefined &&
      thankYouHeroInfo[0].content.desc.split("|") &&
      thankYouHeroInfo[0].content.desc.split("|")[1]
        ? thankYouHeroInfo[0].content.desc.split("|")[1]
        : "";

    const handlePdf = (slugId) => {
      axios
        .get("/brc/getPDFUrl", {
          params: {
            slugID: slugId === "borderless-commerce-ent" ? "4-global-eCommerce-trends-to-watch" : slugId,
          },
        })
        .then(function (response) {
          const gatewayInfo = deserializeJSON(response.data.results);
          const pdfURL = gatewayInfo["pdf-link"];
          const appendHttp = `https://${pdfURL}`;
          if (pdfURL.substring(0, 4) === "http") {
            window.open(pdfURL, "_blank");
          } else {
            window.open(appendHttp, "_blank");
          }
        })
        .catch(function (error) {
          console.log("error", error.message);
        });
    }

    return (
      <div id="thankyou-hero">
        <section className="thankyouHero" style={bgImageStyle}>
          <div className="container">
            <div className="row">
              <div className="thankyouHero__container col-xs-12 col-lg-11 text-xs-center">
                <h2
                  className="text-font h2 thankyouHero__headline"
                  id="contentHeading"
                >
                  <span>{title}</span>
                </h2>
                <h2
                  className="sub-text-font h2 thankyouHero__headline mr-10"
                  id="contentSubHeading"
                >
                  <span>{description}</span>
                </h2>
                {isDownloadBtnExist && <button
                  className="thankyou_download_btn"
                  type="button"
                  onClick={()=>handlePdf(slugId)}  
                >
                  {getTYContent('brc.downloadBtnText')}
                </button>}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default ThankyouHerocontainer;
